/**
 * Compute the displayed status for a chauffeur or vehicle.
 *
 * Combines the manual `status` column (set by the Disable button) with the
 * computed `is_compliant` flag (set by the backend from required docs).
 *
 * Returns a small object the status pill can render directly:
 *   { tone: 'success' | 'danger' | 'warn',
 *     label: string,
 *     reasons: string[] }
 *
 * tone:
 *   - 'success' → green pill, "Active"
 *   - 'danger'  → red pill, "Inactive"
 *   - 'warn'    → amber pill (reserved — not used today)
 */
const REASON_LABELS = {
    manually_disabled: 'Disabled by owner',
    documents_expired: 'Documents expired',
    documents_missing: 'Documents missing',
    engagement_ended: 'Engagement ended',
};

export function computeDisplayStatus(entity) {
    if (!entity) return { tone: 'neutral', label: '—', reasons: [] };

    const reasons = entity.inactive_reasons || [];
    const isUsable = entity.status === 'active' && entity.is_compliant !== false;

    if (isUsable) {
        return { tone: 'success', label: 'Active', reasons: [] };
    }

    return {
        tone: 'danger',
        label: 'Inactive',
        reasons: reasons.map(r => REASON_LABELS[r] || r),
    };
}
